const { createConsentTracking } = require("./src/consent-tracking");

let tracking;

exports.onClientEntry = () => {
  const config = document.getElementById("tracking-config");
  if (config && !tracking) {
    tracking = createConsentTracking(window, JSON.parse(config.textContent));
  }
};

exports.onRouteUpdate = ({ location, prevLocation }) => {
  tracking?.onRouteUpdate();
  if (
    prevLocation?.pathname === "/boka-samtal/" ||
    prevLocation?.pathname === "/boka-samtal/delta-i-videomöte/"
  ) {
    if (typeof vngage !== "undefined") {
      // eslint-disable-next-line no-undef
      vngage.removeAllBanners?.(true);
    }
  }
  if (
    location.pathname === "/boka-samtal/" ||
    location.pathname === "/boka-samtal/delta-i-videomöte/"
  ) {
    if (typeof vngage !== "undefined") {
      // eslint-disable-next-line no-undef
      vngage.evaluateOpportunities?.();
      //vngage.triggerOpportunity?.("ADFCFB5D-8BC9-4BFA-BFD7-8FB4E9EAEDCC");
    }
  }
};
